import { createStore } from 'react-use-sub';
import { Token } from '@hugendubel/ws_client';

export type State = Readonly<{
    wsToken: Token | null;
    triggerRetry: boolean;
}>;

export const initialState: State = {
    wsToken: null,
    triggerRetry: false,
};

const [useSub, Store] = createStore<State>(initialState);

export { useSub, Store };
